export function darkenHex(hex, percent) {
    // Remove "#" if present
    hex = hex.replace(/^#/, '');

    // Convert to RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Darken each channel
    r = Math.max(0, Math.floor(r * (1 - percent / 100)));
    g = Math.max(0, Math.floor(g * (1 - percent / 100)));
    b = Math.max(0, Math.floor(b * (1 - percent / 100)));

    // Convert back to hex
    let darkHex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;

    return darkHex;
}

export function hexToRgba(hex, opacity) {
    // Remove the "#" if it exists
    hex = hex.replace('#', '');

    // If the hex code is 3 characters long (e.g., #FFF), expand it to 6 characters (e.g., #FFFFFF)
    if (hex.length === 3) {
        hex = hex.split('').map(function (char) {
            return char + char;
        }).join('');
    }

    // Extract the red, green, blue values from the hex string
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);

    // Return the RGBA value with the opacity added
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}